module.exports = __webpack_public_path__ + "static/img/img6.9fdfe57.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/scenariusze/img/img6.png
// module id = GtY6
// module chunks = 0